import {Request, IRequestOptions} from 'Core/Common/Request';
import {P} from 'Core/Common/Promise';
import { Deserialize, GenericDeserialize } from '../../../../libs/cerialize';
import {CopyRecordsResponseModel} from 'Core/Controls/ButtonCopy/Models/CopyRecordsResponseModel';

export interface CopyRecordsDto {
	SubjectEntityId: Number;
	SubjectRecordId: Number;
	SubjectTypeId: Number;

	EntityIdToCopy: Number;

	RecordsToCopy: Array<RecordToCopyDto>;

	CopyRelations: boolean,
	CopyFirstRelationTypeValueLinks: boolean;
	IsLinkToSource: boolean;
	CopyToTypeId: number;
	AliasSuffix: string;
	RelationsToCopy: Array<Number>;
	RemoveAlias: string;

	CopyGallery: boolean;
}

export interface RecordToCopyDto {
	Id: Number;
	TypeId: Number;
	KSeq: Number;
}

export class ButtonCopyApi {

	static  CopyRecords(params: CopyRecordsDto): P.Promise<CopyRecordsResponseModel>{
		let deferredResult = P.defer<CopyRecordsResponseModel>();

		let requestParams: IRequestOptions = {
			proxy: {
				url: '/api/ScreenFormApi/CopyRecords',
				dataType: 'json',
				type: 'POST'
			}, params: params
		};

		Request.Send(requestParams)
			.then(data => {
				deferredResult.resolve(GenericDeserialize(data, CopyRecordsResponseModel));
			})
			.fail(error => deferredResult.reject(error));

		return deferredResult.promise();
	}
}